// NewCategory.js
import React, { useState ,useEffect} from 'react';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import './NewCategory.css';
import { baseUrl } from '../components/constant';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css'; // Ensure toastify styles are imported
import Select from 'react-select';
const NewCategory = () => {
  const [name, setName] = useState('');
  const [nameAr, setNameAr] = useState('');
  const [imageUrl, setImageUrl] = useState('');
  const [newImage, setNewImage] = useState(null);
  const [NewImageView, setNewImageView] = useState(null);
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [BrandList, setBrandList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const options = []

  const navigate = useNavigate();


  const fetchBrands = async () => {
    setLoading(true);
    try {
      const token = JSON.parse(localStorage.getItem('token'));
      const response = await fetch(`${baseUrl}/categories/brands`, {
        method: 'GET',
        headers: {
          'Accept': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
      });

      if (response.ok) {
        const data = await response.json();
        console.log("data",data)
        setBrandList(data.brands); // Adjust based on your API response structure
      } else {
        toast.error('Failed to fetch brand');
      }
    } catch (err) {
      setError('Failed to fetch brand');
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchBrands();
  }, []);


  const handleSave = async (e) => {
    e.preventDefault();
    setError('')
    if (!name) {
      toast.error('Please enter english category name.');
      return;
    }
    if (!nameAr) {
      toast.error('Please enter arabic category name.');
      return;
    }
    if (!newImage) {
      toast.error('Please select an image.');
      return;
    }
    setLoading(true);

    try {
      const token = JSON.parse(localStorage.getItem('token'));
      if (!token) {
        toast.error('You are not authenticated.');
        return;
      }
      const formData = new FormData();
      formData.append('name[en]', name);
      formData.append('name[ar]', nameAr);
      formData.append('photo', newImage);
      selectedOptions.forEach(option => {
        formData.append('brand_ids[]', option.value); // 'value' contains the ID
      });

      const response = await fetch(baseUrl + '/categories', {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          "Authorization": 'Bearer ' + token,
        },
        body: formData,
      });

      const data = await response.json();
      if (response.ok) {
        toast.success('added successfully');
        navigate('/Categories');// Redirect to the home page within the root layout
      } else {
        if (data.errors) {
          if (data.errors.name) {
            toast.error(data.errors.name[0]);
          }
        }
      }
    } catch (err) {
      console.log("err", err)
      // Handle network or unexpected errors
      setError('An error occurred. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  // const handleImageChange = (event) => {
  //   if (event.target.files && event.target.files[0]) {
  //     setNewImage(URL.createObjectURL(event.target.files[0]));
  //   }
  // };

  const handleImageChange = (event) => {
    if (event.target.files && event.target.files[0]) {
      const file = event.target.files[0];
      const validTypes = ['image/jpeg', 'image/jpg', 'image/png'];
      if (!validTypes.includes(file.type)) {
        toast.error('Please select a valid image file (jpeg, jpg, png).');
        return;
      }
      setNewImage(file); // Store the file object
      setNewImageView(URL.createObjectURL(event.target.files[0]));
    }
  };

  const formattedOptions = BrandList.map(option => ({
    value: option.id,
    label: `${option.name.en} - ${option.name.ar}`,
  }));

  const handleChange = selected => {
    setSelectedOptions(selected);
  };



  const customStyles = {
    control: (base) => ({
      ...base,
      backgroundColor: "#fff",
      fontSize: 20,
      color: "#000",
      border: "1px solid #ccc",
      boxShadow: "none",
      "&:hover": {
        border: "1px solid #888",
      },
      width: "100%",
      margin: "0 auto", // Center align
    }),
    option: (base, { isFocused, isSelected }) => ({
      ...base,
      backgroundColor: isSelected
        ? "rgba(154, 57, 57, 0.8)"
        : isFocused
          ? "rgba(154, 57, 57, 0.2)"
          : "#fff",
      color: isSelected ? "#fff" : "#000",
      fontSize: 18,
      padding: 10,
    }),
    multiValue: (base) => ({
      ...base,
      backgroundColor: "rgba(154, 57, 57, 0.2)",
      color: "#000",
      fontSize: 16,
      borderRadius: 5,
    }),
    multiValueLabel: (base) => ({
      ...base,
      color: "#000",
    }),
    multiValueRemove: (base) => ({
      ...base,
      color: "#000",
      ":hover": {
        backgroundColor: "rgba(154, 57, 57, 0.8)",
        color: "#fff",
      },
    }),
  };

  return (
    <div style={{ width: '100%', justifyContent: "center" }}>
      {loading && (
        <div className="loader-overlay">
          <div className="loader"></div>
        </div>
      )}


      <h2 style={{ color: "#000", textAlign: 'center' }}>New category</h2>
      <div className="new-category-container">
        <div className="new-category">
          <div className="new-form-group">
            <label htmlFor="name">Name</label>
            <input
              style={{ backgroundColor: "#fff", fontSize: 20, width: "80%", color: "#000" }}
              placeholder='English Category name'
              required
              type="text"
              id="name"
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
          </div>

          <div className="new-form-group">
            <label htmlFor="name">Name</label>
            <input
              style={{ backgroundColor: "#fff", fontSize: 20, width: "80%", color: "#000" }}
              placeholder='Arabic Category name'
              required
              type="text"
              id="namear"
              value={nameAr}
              onChange={(e) => setNameAr(e.target.value)}
            />
          </div>


          <div  style={{
            width: "70%",
            color: "#000",
            display:'contents'
          }}>
            <h3>Select Brands</h3>
            <Select
              options={formattedOptions}
              isMulti
              onChange={handleChange}
              value={selectedOptions}
              styles={customStyles}
            />
          </div>

          <div className="new-form-group">
            <label htmlFor="imageUrl">Image</label>
            <div className="image-preview">
              <label htmlFor="imageUpload" className="upload-label">
                {NewImageView ? (
                  <img src={NewImageView} alt="Category" className="newcategory-image" />
                ) : (
                  <FontAwesomeIcon icon={faPlus} className="add-icon" />
                )}
              </label>
              <input
                required
                type="file"
                id="imageUpload"
                accept="image/*"
                onChange={handleImageChange}
                style={{ display: 'none' }}
              />
            </div>
          </div>
          <div className="form-buttons">
            <button onClick={handleSave} style={{ backgroundColor: "rgb(154, 57, 57)" }}>Save</button>
            <button onClick={() => navigate('/Categories')} style={{ backgroundColor: "#000" }}>Cancel</button>
          </div>
        </div>
      </div>
      <ToastContainer />
    </div>
  );
};

export default NewCategory;
